<template>
	<div id="contacts" class="contacts" @keydown.esc="isModalOpen = false">
		<div class="contacts__item">
			<UIHeading level="3" class="contacts__item-title">
				{{ $t('pages.main.sections.footer.contacts.title') }}
			</UIHeading>
			<div class="contacts__item-list">
				<a
					v-for="({ type, title, href, ymId }, i) in CONTACTS"
					:key="i"
					:href="type === 'tel' ? `tel:${href}` : `mailto:${href}`"
					class="contacts__item-link"
					@click="handleYmGoal(ymId)">
					<Icon :name="type === 'tel' ? 'mdi:phone' : 'mdi:email'" size="24" />
					<span>{{ title }}</span>
				</a>
			</div>
			<button type="button" class="common-btn contacts__btn" @click="handleGetInTouch">
				{{ $t('pages.main.sections.footer.contacts.btnText') }}
			</button>
		</div>
		<div class="contacts__item">
			<UIHeading level="3" class="contacts__item-title">
				{{ $t('pages.main.sections.footer.socials.title') }}
			</UIHeading>
			<div class="contacts__item-list socials">
				<NuxtLink
					v-for="({ type, title, href, ymId }, i) in SOCIALS"
					:key="i"
					:to="href"
					target="_blank"
					class="contacts__item-link"
					@click="handleYmGoal(ymId)">
					<Icon :name="`mdi:${type}`" size="32" />
					<span>{{ title }}</span>
				</NuxtLink>
			</div>
		</div>
		<div class="contacts__item">
			<UIHeading level="3" class="contacts__item-title">
				{{ $t('pages.main.sections.footer.news.title') }}
			</UIHeading>
			<div class="contacts__item-list">
				<span class="disabled" role="link" aria-disabled="true">
					{{ $t('pages.main.sections.footer.news.news') }}
				</span>
				<span class="disabled" role="link" aria-disabled="true">
					{{ $t('pages.main.sections.footer.news.cases') }}
				</span>
				<NuxtLinkLocale to="/legal" @click="handleYmGoal('legal')">
					{{ $t('pages.main.sections.footer.news.legal') }}
				</NuxtLinkLocale>
				<NuxtLinkLocale to="/publishers" class="contacts__publishers" @click="handleYmGoal('publishers')">
					{{ $t('menu.publishers') }}
					<Icon name="mdi:arrow-right" size="16" />
				</NuxtLinkLocale>
			</div>
		</div>
		<div class="contacts__item">
			<UIHeading level="3" class="contacts__item-title">
				{{ $t('pages.main.sections.footer.about.title') }}
			</UIHeading>
			<div class="contacts__item-list">
				<span class="disabled" role="link" aria-disabled="true">
					{{ $t('pages.main.sections.footer.about.about') }}
				</span>
				<span class="disabled" role="link" aria-disabled="true">
					{{ $t('pages.main.sections.footer.about.careers') }}
				</span>
				<span class="disabled" role="link" aria-disabled="true">
					{{ $t('pages.main.sections.footer.about.management') }}
				</span>
				<span class="disabled" role="link" aria-disabled="true">
					{{ $t('pages.main.sections.footer.about.complience') }}
				</span>
			</div>
		</div>

		<BlocksFooterModal v-model:is-modal-open="isModalOpen" />

		
	</div>
</template>

<script setup lang="ts">
	import { CONTACTS, SOCIALS } from '~/constants/contacts'

	const { reachGoal } = useYandexMetrika()

	const isModalOpen = ref(false)

	// const formData = reactive({
	// 	name: '',
	// 	phone: '',
	// 	email: '',
	// 	task: '',
	// })

	// const handleOpenModal = () => {
	// 	isModalOpen.value = true
	// }

	const handleGetInTouch = () => {
		reachGoal('get_in_touch')
		isModalOpen.value = true
	}

	const handleYmGoal = (ymId?: string) => {
		if (ymId) {
			reachGoal(ymId)
		}
	}

	// const handleSumbitForm = () => {
	// 	console.log(formData)
	// 	for (const key in formData) {
	// 		formData[key as keyof typeof formData] = ''
	// 	}
	// 	isModalOpen.value = false
	// }
</script>

<style scoped lang="scss">
	.contacts {
		z-index: 2;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 32px;

		@media (width <= 575.98px) {
			grid-template-columns: 1fr;
			gap: 64px;
		}
		&__item {
			color: var(--white);

			@media (width <= 991.98px) {
				text-align: center;
			}
			&-title {
				color: var(--primary);
				text-transform: uppercase;
			}
			&-list {
				display: flex;
				flex-direction: column;
				gap: 16px;
				margin-top: 16px;

				@media (width <= 991.98px) {
					align-items: center;
					justify-content: center;
				}
				&.socials {
					display: grid;
					grid-template-columns: repeat(2, 1fr);

					@media (width <= 991.98px) {
						display: flex;
						flex-direction: column;
					}
				}
			}
			&-link {
				display: flex;
				gap: 8px;
				align-items: center;
				transition: 0.4s color;
				&:hover {
					color: var(--primary);
				}
			}
		}
		&__btn{
			margin-top: 16px;
		}
		&__publishers {
			display: inline-flex;
			gap: 6px;
			align-items: center;
			width: max-content;
			transition:
				gap 0.4s,
				color 0.4s;

			&:hover {
				gap: 10px;
				color: var(--primary);
			}
		}

		// &__btn {
		// 	max-width: max-content;
		// 	padding: 16px;
		// 	margin-top: 16px;
		// 	font-weight: bold;
		// 	color: var(--black);
		// 	background-color: var(--primary);
		// 	border-radius: 10px;
		// 	&:hover {
		// 		background-color: var(--primary-hover);
		// 	}
		// }
	}
</style>
